<template>
    <div class="pb-3">
        <batch-result-manager-table-filters @filterApply="applyFilter" />
        <batch-result-manager-server-table 
            v-if="filters && analyteResult && status_options" 
            :status_options="status_options" 
            :loading="loading"  
            :filters="filters" 
            :collection="analyteResult" 
            @result_emited="analyteUpdated"
        />
    </div>
</template>

<script>
import BatchResultManagerTableFilters from './BatchResultManagerTableFilters';
import BatchResultManagerServerTable from './BatchResultManagerServerTable';
import { getCollection } from "@/shared/fetch-utils";
import moment from 'moment';
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";

export default {
    name: "BatchResultManagerTable",
    components: {
        BatchResultManagerTableFilters,
        BatchResultManagerServerTable,
    },
    mixins: [ToastNotifications],
    data() {
        return {
            filters: null,
            analyteResult: null,
            loading: true,
            status_options: [],
        };
    },
    methods: {
        async getStatuses() {
            const statuses = await getCollection({
                collection_type: "analyte_result_status",
                message: this.$bvToast
            });

            this.status_options = this.status_options.concat(statuses.map(({id, status}) => {
                if (id && status) {

                    return { value: id, text: status };
                }
            }));
        },
        applyFilter(filter) {
            this.filters = filter;
            this.getAnalyteResults();
        },
        analyteUpdated() {
            this.getAnalyteResults();
        },
        async getAnalyteResults() {
            this.loading = true; 

            this.analyteResult = await getCollection({
                collection_type: "analyte_result",
                connections: ["sample.submission", "analyte_result_status_logs", "createdBy"],
                limit: "all",
                filters: this.compileFilters(),
            });

            this.loading = false;
        },
        compileFilters() {
            let filterObj = [
                {
                    logic: "filterEquals",
                    field: "instrument_instance.laboratory_id",
                    value: this.$store.getters.getLaboratoryContext.id
                }
            ];
            
            for (const filter in this.filters) {
                let newFilter = {};

                if (!this.filters[filter]) {
                    continue;
                }

                switch(filter) {
                    case "filter_date":
                        newFilter.logic = "filterGreaterEqual";
                        newFilter.field = "created_at";
                        this.filters[filter] = moment(this.filters[filter]).format("YYYY-MM-DD HH:mm:SS")
                        filterObj.push({
                            logic: "filterLess",
                            field: "created_at",
                            value: moment(this.filters[filter]).endOf('day').format("YYYY-MM-DD HH:mm:SS")
                        })
                        break;
                    case "schedule": 
                        // need to continue the loop not break out of the switch
                        continue;
                    case "sample_type": 
                        newFilter.logic = "filterEquals";
                        newFilter.field = "sample.submission.sample_type_id";
                        break;
                    case "task_type":
                        newFilter.logic = "filterEquals";
                        newFilter.field = "schedulable_task_type";
                        break;
                    case "task":
                        newFilter.logic = "filterEquals";
                        newFilter.field = "schedulable_task_id"
                        break;
                    case "status":
                        newFilter.logic = "filterEquals";
                        newFilter.field = "current_analyte_result_status_log.analyte_result_status_id"
                        break;
                    case "analyte":
                        newFilter.logic = "filterEquals";
                        newFilter.field = "analyte_id";
                        break;
                    case "instrument":
                        newFilter.logic = "filterEquals";
                        newFilter.field = "instrument_instance_id";
                        break;
                    case "user":
                        newFilter.logic = "filterEquals";
                        newFilter.field = "created_by";
                        break;
                    }
                        
                newFilter.value = this.filters[filter];
                if (Object.keys(newFilter).length) {
                    filterObj.push(newFilter)
                }
            }
            
            return filterObj;
        }
    },
    mounted() {
        this.getAnalyteResults();
        this.getStatuses();
    }
};
</script>